<div class="main-cnt d-flex justify-content-center align-items-center vw-100 vh-100">
  <div class="overlay-bg"></div>
  <div class="p-3 text-center p-2 m-2 text-cnt">
    <h1>{{ header }}</h1>
    <p>{{ 'GENERIC.COMMON_PAGES.SERVICE_UNAVAILABLE_BODY' | translate }}, {{ 'GENERIC.COMMON_PAGES.CHECK_BACK_SOON' |
      translate | lowercase }}</p>
  </div>
</div>
